import { css } from 'styled-components';

/**
 * Utility style to handle overflow in single line labels
 */
export const handleTextOverflow = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const darkBackgroundBlur = css`
  html[data-theme='dark'] &&,
  .dark && {
    backdrop-filter: blur(4px);
  }
`;

export const hideScrollBar = css`
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
